import React from 'react';
import PlaylistAddIcon from '@material-ui/icons/PlaylistAdd';
import {MainNavigation} from "@cabinet-packages/components";
import {
    ActionsDetails,
    OrdersHistory,
    PatientCard,
    ResearchStatus,
} from '@cabinet-packages/pages';
import ResearchDetails from '../pages/ResearchDetails';
import Catalog from '../pages/Catalog';
import CollectionPoints from '../pages/CollectionPoints';
import UpdateIcon from "@material-ui/icons/Update";
import OrderManager from "../pages/OrderManager";
import Authentication from "../pages/Authentication";
import PartnerOrderedAssays from "../pages/PartnerOrderedAssays";
import AssaySchedulerTimePartner from "@cabinet-packages/components/scduler/AssaySchedulerTimePartner";
import SearchPatientResults from "../pages/SearchPatientResults";
import LiqPayPage from "../pages/LiqPayPage";
import CrmReport from "../pages/CrmReport";
import searchIcon from '../assets/images/search.svg';
import pointsIcon from '../assets/images/points.svg';
import catalogIcon from '../assets/images/catalog.svg';
import assaysIcon from '../assets/images/assays.svg';



const routes = [
    {
        path: '/search-patient-results',
        component: () => <SearchPatientResults/>,
        label: 'Пошук результатів',
        showInNavigation: true,
        underAuth : true,
        icon: <img src={searchIcon} alt="Пошук результатів" className="nav-icon"/>,
    },
    {
        path: '/patient-orders-history',
        component: () => <OrdersHistory/>,
        label: 'Замовлені дослідження',
        underAuth : true,
        showInNavigation: false,
        icon: <UpdateIcon color="inherit" fontSize="inherit"/>,
    },
    {
        path: '/collection-points',
        component: () => <CollectionPoints/>,
        label: 'Пункти забору',
        showInNavigation: true,
        underAuth : true,
        icon: <img src={pointsIcon} alt="Пункти забору" className="nav-icon"/>,
    },
    {
        path: '/research-status',
        underAuth : true,
        component: () => <ResearchStatus/>,
        showInNavigation: false,
        icon: <PlaylistAddIcon color="inherit" fontSize="inherit"/>,
    },
    {
        path: '/main-navigation',
        component: () => <MainNavigation/>,
        label: 'Головне меню',
        showInNavigation: false,
        underAuth : true,
    },
    {
        path: '/actions-details',
        component: () => <ActionsDetails/>,
        label: 'Деталі акції',
        underAuth : true,
        showInNavigation: false,
    },
    {
        path: '/complex-info/:id',
        component: () => <ResearchDetails/>,
        label: 'Деталі комплексу',
        underAuth : true,
        showInNavigation: false,
    },
    {
        path: '/catalog',
        component: () => <Catalog/>,
        underAuth : true,
        label: 'Перелік досліджень',
        showInNavigation: true,
        icon: <img src={catalogIcon} alt="Перелік досліджень" className="nav-icon"/>,
    },
    {
        path: '/patient-card',
        component: () => <PatientCard/>,
        underAuth : true,
        label: 'Карта пацієнта',
        showInNavigation: false,
    },
    // {
    //     path: '/account-settings',
    //     component: () => <AccountSettings/>,
    //     underAuth : true,
    //     label: 'Особистий кабінет лікаря',
    //     showInNavigation: false,
    // },
    // {
    //     path: '/add-new-patient',
    //     component: () => <AddNewPatient/>,
    //     underAuth : true,
    //     label: 'Додавання нового пацієнта',
    //     showInNavigation: false,
    // },
    // {
    //     path: '/notification-manager',
    //     component: () => <NotificationManager/>,
    //     label: 'Сповіщення',
    //     underAuth : true,
    //     showInNavigation: false,
    // },
    {
        path: '/assay-info/:id',
        component: () => <ResearchDetails/>,
        underAuth : true,
        label: 'Інформація про дослідження',
        showInNavigation: false,
    },
    // {
    //     path: '/auth',
    //     component: () => <AuthPage/>,
    //     underAuth : false,
    //     hasOwnPage : true,
    //     showInNavigation: false,
    // },
    {
        path: '/auth',
        component: () => <Authentication/>,
        underAuth : false,
        hasOwnPage : true,
        showInNavigation: false,
    },
    {
        path: '/order-manager',
        underAuth : true,
        component: () => <OrderManager/>,
        label: 'Керування замовленнями',
        showInNavigation: false,
    },
    {
        path: '/doctor-ordered-assays',
        component: () => <PartnerOrderedAssays/>,
        underAuth : true,
        label: 'Призначені дослідження',
        showInNavigation: true,
        icon: <img src={assaysIcon} alt="Призначені дослідження" className="nav-icon"/>,
    },
    {
        path: '/assay-scheduler-time',
        component: () => <AssaySchedulerTimePartner/>,
        label: 'Вибір часу',
        showInNavigation: false,
        underAuth : true,
    },
    // {
    //     path: '/comprehensive-research',
    //     component: () => <ComprehensiveResearchCards/>,
    //     label: 'Комплексні дослідження',
    //     underAuth : true,
    //     showInNavigation: true,
    //     icon: <FormatLineSpacingIcon color="inherit" fontSize="inherit"/>,
    // },
    {
        path: '/liqPayPage/:id',
        component: () => <LiqPayPage/>,
        label: 'Оплата',
        underAuth : false,
        showInNavigation: false,
    },
     {
        path: '/report/document/:hash',
        component: () => <CrmReport/>,
        label: 'акт',
        underAuth : false,
        showInNavigation: false,
    }
];

export default routes;
